import React from 'react';
import LayoutContentWrapper from './layoutWrapper.style';

export default props => (
  <LayoutContentWrapper className={props.className}>
    {props.children}
  </LayoutContentWrapper>
);
